import React from 'react'
import { OKButton } from 'commonsComponents/OKButton'
import PropTypes from "prop-types";
import { translateText } from "../../../getTranslationsMyProfileUploadDocumentation";

const { formatText } = require('core/i18n').i18n;

export const Footer = ({ onContinue, onExit, isContinueDisabled, isLoading }) => {
    return (
        <div className="upload-footer">
            <a href={'#'} onClick={onExit} className={"cancel-link"}>{formatText('common-cancel')}</a>
            <OKButton
                disabled={isContinueDisabled}
                modifier="primary"
                onClick={onContinue}
                loaderColor="dark"
                loading={isLoading}
            >
                {translateText('buttonAttached')}
            </OKButton>
        </div>
    );
}

Footer.propTypes = {
    onContinue: PropTypes.func,
    onExit: PropTypes.func,
    isContinueDisabled: PropTypes.bool,
    isLoading: PropTypes.bool
};